var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
/**
 * Generic actions for a list of serializable objects.
 * Objects must be of type Serializable with a prepopulated uid field.
 */
let CollectionActions = CollectionActions_1 = class CollectionActions {
    set(collectionName, items) {
        return {
            type: CollectionActions_1.SET,
            payload: items,
            collectionName: collectionName,
        };
    }
    append(collectionName, items) {
        return {
            type: CollectionActions_1.APPEND,
            payload: items,
            collectionName: collectionName,
        };
    }
    add(collectionName, item) {
        return {
            type: CollectionActions_1.ADD,
            payload: item,
            collectionName: collectionName,
        };
    }
    insert(collectionName, item) {
        return {
            type: CollectionActions_1.INSERT,
            payload: item,
            collectionName: collectionName,
        };
    }
    update(collectionName, item) {
        return {
            type: CollectionActions_1.UPDATE,
            payload: item,
            collectionName: collectionName,
        };
    }
    setLoading(collectionName, loading) {
        return {
            type: CollectionActions_1.SET_LOADING,
            payload: loading,
            collectionName: collectionName,
        };
    }
    setWithPageInfo(collectionName, pagedItems) {
        return {
            type: CollectionActions_1.SET_WITH_PAGE_INFO,
            payload: pagedItems,
            collectionName: collectionName,
        };
    }
    delete(collectionName, item) {
        return {
            type: CollectionActions_1.DELETE,
            payload: item,
            collectionName: collectionName,
        };
    }
    clearAll() {
        return {
            type: CollectionActions_1.CLEAR_ALL,
        };
    }
};
CollectionActions.SET = 'SET';
CollectionActions.APPEND = 'APPEND';
CollectionActions.ADD = 'ADD';
CollectionActions.INSERT = 'INSERT';
CollectionActions.UPDATE = 'UPDATE';
CollectionActions.SET_LOADING = 'SET_LOADING';
CollectionActions.SET_WITH_PAGE_INFO = 'SET_WITH_PAGE_INFO';
CollectionActions.DELETE = 'DELETE';
CollectionActions.CLEAR_ALL = 'CLEAR_ALL';
CollectionActions = CollectionActions_1 = __decorate([
    Injectable()
], CollectionActions);
export { CollectionActions };
var CollectionActions_1;
//# sourceMappingURL=actions.js.map


// WEBPACK FOOTER //
// ./src/state/actions.ts.pre-build-optimizer.js